import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { selectOutskirtBuildingVisualLevelFromInfo } from "../../selectors/selectOutskirtBuildingInfo";
import { BF2GetOutskirtBuildingCafe } from "./BF2GetOutskirtBuildingCafe";
import { BF2GetOutskirtBuildingDoghouse } from "./BF2GetOutskirtBuildingDoghouse";
import { BF2GetOutskirtBuildingExternalBarn } from "./BF2GetOutskirtBuildingExternalBarn";
import { BF2GetOutskirtBuildingHarbor } from "./BF2GetOutskirtBuildingHarbor";
import { BF2GetOutskirtBuildingLibrary } from "./BF2GetOutskirtBuildingLibrary";
import { BF2GetOutskirtBuildingMarket } from "./BF2GetOutskirtBuildingMarket";
import { BF2GetOutskirtBuildingNursery } from "./BF2GetOutskirtBuildingNursery";
import { BF2GetOutskirtBuildingPier } from "./BF2GetOutskirtBuildingPier";
import { BF2GetOutskirtBuildingThemedEvent } from "./BF2GetOutSkirtBuildingThemedEvent";
import { BF2GetOutskirtBuildingTournamentTent } from "./BF2GetOutskirtBuildingTournamentTent";
import { BF2GetOutskirtBuildingWatertower } from "./BF2GetOutskirtBuildingWatertower";
var DisplayObject = PIXI.DisplayObject;
var mapGetOutskirtGraphics = new Map([
    [IdOutskirtBuildings.Market, BF2GetOutskirtBuildingMarket],
    [IdOutskirtBuildings.Doghouse, BF2GetOutskirtBuildingDoghouse],
    [IdOutskirtBuildings.Watertower, BF2GetOutskirtBuildingWatertower],
    [IdOutskirtBuildings.Nursery, BF2GetOutskirtBuildingNursery],
    [IdOutskirtBuildings.Library, BF2GetOutskirtBuildingLibrary],
    [IdOutskirtBuildings.ExternalBarn, BF2GetOutskirtBuildingExternalBarn],
    [IdOutskirtBuildings.Harbor, BF2GetOutskirtBuildingHarbor],
    [IdOutskirtBuildings.Pier, BF2GetOutskirtBuildingPier],
    [IdOutskirtBuildings.Cafe, BF2GetOutskirtBuildingCafe],
    [IdOutskirtBuildings.TournamentTent, BF2GetOutskirtBuildingTournamentTent],
    [IdOutskirtBuildings.ThemedEvent, BF2GetOutskirtBuildingThemedEvent],
]);
export var GetOutskirtBuildingGraphic = function (data, buildingState, isAccessible, buildingName) {
    if (isAccessible === void 0) { isAccessible = true; }
    var id = data.balancing.id;
    var getFn = mapGetOutskirtGraphics.get(id);
    var level = selectOutskirtBuildingVisualLevelFromInfo(data);
    // Handle special cases
    var hasLevelZeroWhenLocked = id === IdOutskirtBuildings.Nursery ||
        id === IdOutskirtBuildings.Library ||
        id === IdOutskirtBuildings.ExternalBarn;
    if (!isAccessible && hasLevelZeroWhenLocked) {
        level = 0;
    }
    if (getFn) {
        return getFn(data, level, buildingState, isAccessible, buildingName);
    }
    return new DisplayObject();
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/GetOutskirtBuildingGraphic.ts
// module id = 2159
// module chunks = 3